module.exports = __webpack_public_path__ + "media/step5_Kernaufgaben_animation.cb663bb3.webm";